/**
 * Quiz Configurations
 * Define all quiz questions and settings here
 */

window.quizConfigs = {
  // Aligners Quiz Configuration
  aligners: {
    id: 'aligners-quiz',
    logoUrl: '//cdn.shopify.com/s/files/1/0364/6911/2965/files/Small_newsmile-logo-165x47.png?v=1607468400',
    logoAlt: 'NewSmile',
    webhookUrl: 'https://hooks.zapier.com/hooks/catch/YOUR_WEBHOOK_ID/',
    successRedirect: '/pages/smile-assessment-thank-you',
    
    questions: [
      {
        id: 'why-straighten',
        type: 'radio',
        title: 'Why do you want to straighten your teeth?',
        required: true,
        layout: 'grid-3',
        autoAdvance: true,
        options: [
          { value: 'career', label: 'Career' },
          { value: 'married', label: 'Getting married' },
          { value: 'self-improvement', label: 'Self-improvement' },
          { value: 'oral-health', label: 'Overall oral health' },
          { value: 'other', label: 'Other: please specify', hasTextInput: true }
        ],
        errorMessage: 'Please select a reason'
      },
      {
        id: 'age-check',
        type: 'radio',
        title: 'Are you 13 years old or older?',
        required: true,
        layout: 'grid-2',
        autoAdvance: true,
        options: [
          { value: 'yes', label: 'Yes', highlighted: true },
          { value: 'no', label: 'No', disqualifies: true }
        ],
        errorMessage: 'Please confirm your age'
      },
      {
        id: 'teeth-condition',
        type: 'image-radio',
        title: 'Which picture best represents what you want to change?',
        required: true,
        layout: 'grid-3',
        autoAdvance: true,
        options: [
          { 
            value: 'spacing', 
            label: 'Spacing',
            image: 'https://cdn.shopify.com/s/files/1/1955/2453/files/Issues-01.png?51607'
          },
          { 
            value: 'crowding', 
            label: 'Crowding',
            image: 'https://cdn.shopify.com/s/files/1/1955/2453/files/Issues-02.png?51607'
          },
          { 
            value: 'minor-tweaks', 
            label: 'Minor Tweaks',
            image: 'https://cdn.shopify.com/s/files/1/1955/2453/files/Issues-03.png?51607'
          }
        ],
        errorMessage: 'Please select your teeth condition'
      },
      {
        id: 'photo-upload',
        type: 'file',
        title: 'Upload a picture.',
        description: 'For feedback on your candidacy for NewSmile clear aligners, upload a picture. Take a photo of your teeth with a natural bite (when relaxed), and show as many teeth as possible. If not, skip this part.',
        required: false,
        buttonText: 'SELECT PHOTO',
        skipOption: true,
        skipText: 'If not, skip this part.',
        accept: 'image/*',
        uploadConfig: {
          provider: 'imgur',
          clientId: '79fa2989ef9fc9e' // Replace with your Imgur client ID
        }
      },
      {
        id: 'braces-history',
        type: 'radio',
        title: 'Have you worn braces in the past?',
        required: true,
        layout: 'grid-2',
        autoAdvance: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        errorMessage: 'Please answer about braces history'
      },
      {
        id: 'permanent-retainer',
        type: 'radio',
        title: 'Do you have a permanent bonded retainer?',
        required: true,
        layout: 'grid-2',
        autoAdvance: false, // Don't auto-advance for this question
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        errorMessage: 'Please answer about permanent retainer',
        onShow: function(quiz) {
          // Custom behavior when this question is shown
          const question = quiz.config.questions[quiz.currentQuestionIndex];
          const questionEl = quiz.form.querySelector(`[data-question-id="${question.id}"]`);
          
          // Add event listener for "Yes" option to show warning
          const yesOption = questionEl.querySelector('input[value="yes"]');
          if (yesOption && !yesOption.hasListener) {
            yesOption.hasListener = true;
            yesOption.addEventListener('change', function() {
              if (this.checked) {
                const modal = document.createElement('div');
                modal.className = 'quiz-overlay';
                modal.innerHTML = `
                  <div class="quiz-modal">
                    <h2>One more thing...</h2>
                    <p>If you have a permanent wire on the teeth you would like aligners for, you will need to remove your retainer before taking your impressions. However, if you are only looking for aligners for one row (the one without a permanent wire), you're all good. Please continue.</p>
                    <button class="quiz-modal-btn quiz-modal-confirm">Next Question</button>
                  </div>
                `;
                document.body.appendChild(modal);
                
                modal.querySelector('.quiz-modal-confirm').addEventListener('click', () => {
                  modal.remove();
                  quiz.nextQuestion();
                });
              }
            });
          }
          
          // Auto-advance on "No"
          const noOption = questionEl.querySelector('input[value="no"]');
          if (noOption && !noOption.hasListener) {
            noOption.hasListener = true;
            noOption.addEventListener('change', function() {
              if (this.checked) {
                setTimeout(() => quiz.nextQuestion(), 300);
              }
            });
          }
        }
      },
      {
        id: 'contact-info',
        type: 'form',
        title: 'Where can we send results and texts to?',
        required: true,
        errorContainer: true,
        submitButton: true,
        submitText: 'Submit',
        fields: [
          {
            id: 'first-name',
            name: 'firstName',
            type: 'text',
            placeholder: 'First Name',
            required: true,
            pattern: '^[a-zA-Z\\s]+$',
            errorMessage: 'First Name is required',
            validationMessage: 'Please enter a valid name (letters only)'
          },
          {
            id: 'email',
            name: 'email',
            type: 'email',
            placeholder: 'Email',
            required: true,
            errorMessage: 'Email is required'
          },
          {
            id: 'phone',
            name: 'phone',
            type: 'tel',
            placeholder: 'Phone Number',
            required: true,
            pattern: '^[\\d\\s\\-\\(\\)]+$',
            errorMessage: 'Phone number is required',
            validationMessage: 'Please enter a valid 10-digit phone number'
          },
          {
            id: 'zip',
            name: 'zipCode',
            type: 'text',
            placeholder: 'Zip Code',
            required: true,
            pattern: '^\\d{5}(-\\d{4})?$',
            errorMessage: 'Zip code is required',
            validationMessage: 'Please enter a valid zip code'
          }
        ],
        disclaimer: `<p style="text-align: justify;color:#888;font-size: 12px;margin-top: 3%;">
          By submitting this form, I consent to receive marketing/promotional text messages from NewSmile. Message and data rates may apply. Message frequency may vary. To end messaging from us, you may always reply with STOP. You may also reply with HELP for more information. Consent is not a condition of purchase. View <a href="/pages/terms-of-service" style="color:#888;text-decoration:underline;">Terms</a> & <a href="/pages/privacy-policy" style="color:#888;text-decoration:underline;">Privacy</a>.
        </p>`
      }
    ],
    
    disqualificationMessage: {
      title: "Unfortunately, we've determined that NewSmile isn't the best option for you right now.",
      content: "We don't recommend clear aligners for people under the age of 13. However, there are certain circumstances where we can still help. To discuss your options further, please reach out to our team of specialists via online chat, phone, text or email.",
      contactInfo: {
        phone: "1-(888)-231-7725",
        email: "team@newsmilelife.com"
      }
    },
    
    successMessage: {
      title: "Thank you for completing your Smile Assessment!",
      content: "We've received your information and our team will review it shortly. You'll receive an email with your personalized treatment plan within 24-48 hours.",
      buttonText: "Return to Homepage",
      buttonUrl: "/"
    }
  },
  
  // Retainers Quiz Configuration
  retainers: {
    id: 'retainers-quiz',
    logoUrl: '//cdn.shopify.com/s/files/1/0364/6911/2965/files/Small_newsmile-logo-165x47.png?v=1607468400',
    logoAlt: 'NewSmile',
    webhookUrl: 'https://hooks.zapier.com/hooks/catch/6478303/2orjoj7/',
    successRedirect: '/pages/retainer-smile-assessment-thank-you',
    
    questions: [
      {
        id: 'reason',
        type: 'radio',
        title: 'Why do you need retainers?',
        required: true,
        layout: 'vertical',
        autoAdvance: true,
        options: [
          { value: 'had-braces', label: 'Had braces' },
          { value: 'had-clear-aligners', label: 'Had clear aligners' },
          { value: 'teeth-grinding', label: 'Teeth grinding' },
          { value: 'teeth-clenching', label: 'Teeth clenching' },
          { value: 'teeth-shifting', label: 'Teeth shifting with age' }
        ],
        errorMessage: 'Reason is required'
      },
      {
        id: 'teeth-shifting',
        type: 'radio',
        title: 'Are your teeth shifting?',
        required: true,
        layout: 'grid-2',
        autoAdvance: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        errorMessage: 'Please answer about teeth shifting'
      },
      {
        id: 'baby-teeth',
        type: 'radio',
        title: 'Have all of your baby teeth fallen out?',
        required: true,
        layout: 'grid-2',
        autoAdvance: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No', disqualifies: true }
        ],
        errorMessage: 'You must indicate whether or not your baby teeth have all fallen out'
      },
      {
        id: 'retainer',
        type: 'radio',
        title: 'Do you have a permanent bonded retainer?',
        required: true,
        layout: 'grid-2',
        autoAdvance: false,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        errorMessage: 'You must tell us if you have a permanent retainer',
        onShow: function(quiz) {
          // Custom behavior for retainer question
          const question = quiz.config.questions[quiz.currentQuestionIndex];
          const questionEl = quiz.form.querySelector(`[data-question-id="${question.id}"]`);
          
          // Add event listener for "Yes" option
          const yesOption = questionEl.querySelector('input[value="yes"]');
          if (yesOption && !yesOption.hasListener) {
            yesOption.hasListener = true;
            yesOption.addEventListener('change', function() {
              if (this.checked) {
                const modal = document.createElement('div');
                modal.className = 'quiz-overlay';
                modal.innerHTML = `
                  <div class="quiz-modal">
                    <h2>One more thing...</h2>
                    <p>If you have a permanent wire on the teeth you would like a retainer for, you will need to remove your retainer before taking your impressions. However, if you are only looking for a retainer for one row (the one without a permanent wire), you're all good. Please continue.</p>
                    <button class="quiz-modal-btn quiz-modal-confirm">Next Question</button>
                  </div>
                `;
                document.body.appendChild(modal);
                
                modal.querySelector('.quiz-modal-confirm').addEventListener('click', () => {
                  modal.remove();
                  quiz.nextQuestion();
                });
              }
            });
          }
          
          // Auto-advance on "No"
          const noOption = questionEl.querySelector('input[value="no"]');
          if (noOption && !noOption.hasListener) {
            noOption.hasListener = true;
            noOption.addEventListener('change', function() {
              if (this.checked) {
                setTimeout(() => quiz.nextQuestion(), 300);
              }
            });
          }
        }
      },
      {
        id: 'contact-info',
        type: 'form',
        title: 'Where can we send results and texts to?',
        required: true,
        errorContainer: true,
        submitButton: true,
        submitText: 'Submit',
        fields: [
          {
            id: 'first-name',
            name: 'firstName',
            type: 'text',
            placeholder: 'First Name',
            required: true,
            pattern: '^[a-zA-Z\\s]+$',
            errorMessage: 'First Name is required',
            validationMessage: 'Please enter a valid name (letters only)'
          },
          {
            id: 'email',
            name: 'email',
            type: 'email',
            placeholder: 'Email',
            required: true,
            errorMessage: 'Email is required'
          },
          {
            id: 'phone',
            name: 'phone',
            type: 'tel',
            placeholder: 'Phone Number',
            required: true,
            pattern: '^[\\d\\s\\-\\(\\)]+$',
            errorMessage: 'Phone number is required',
            validationMessage: 'Please enter a valid 10-digit phone number'
          },
          {
            id: 'zip',
            name: 'zipCode',
            type: 'text',
            placeholder: 'Zip Code',
            required: true,
            pattern: '^\\d{5}(-\\d{4})?$',
            errorMessage: 'Zip code is required',
            validationMessage: 'Please enter a valid zip code'
          }
        ],
        disclaimer: `<p style="text-align: justify;color:#888;font-size: 12px;margin-top: 3%;">
          By submitting this form, you agree to be contacted with information about NewSmile retainers, offers, or other information, including via email, as well as texts, live, video calls and/or prerecorded calls or phone messages using a telephone system with automatic dialing capacity at the number(s) receive recurring automated promotional and personalized marketing text messages (e.g. cart reminders) from NewSmile at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. View <a href="/pages/terms-of-service" style="color:#888;text-decoration:underline;">Terms</a> & <a href="/pages/privacy-policy" style="color:#888;text-decoration:underline;">Privacy</a>.
        </p>`
      }
    ],
    
    disqualificationMessage: {
      title: "Unfortunately, we've determined that NewSmile isn't the best option for you right now.",
      content: "We don't recommend our products for people who haven't lost all their baby teeth. However, there are certain circumstances where we can still help. To discuss your options further, please reach out to our team of specialists via online chat, phone, text or email.",
      contactInfo: {
        phone: "1-(888)-231-7725",
        email: "team@newsmilelife.com"
      }
    },
    
    additionalData: {
      source: function() { 
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('utm_source') || document.referrer || 'direct';
      }
    }
  }
};